import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=26a11f5a&scoped=true"
import script from "./couponList.vue?vue&type=script&lang=js"
export * from "./couponList.vue?vue&type=script&lang=js"
import style0 from "./couponList.vue?vue&type=style&index=0&id=26a11f5a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a11f5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26a11f5a')) {
      api.createRecord('26a11f5a', component.options)
    } else {
      api.reload('26a11f5a', component.options)
    }
    module.hot.accept("./couponList.vue?vue&type=template&id=26a11f5a&scoped=true", function () {
      api.rerender('26a11f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/components/couponList.vue"
export default component.exports